import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const favoritesDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_Favorites: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_Favorites: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
